import React from 'react';
import PropTypes from 'prop-types';

import DefaultPicture from '../../../01_atoms/DefaultPicture';
import Switcher from '../../../02_molecules/Switcher';
import MapSvg from '../../../../public/static/icons/map.svg';
import ListSvg from '../../../../public/static/icons/list.svg';

import FrayedEdge from '../../../01_atoms/FrayedEdge';

import styles from './index.module.scss';

const BBCountryListSwitcher = ({
  title = '',
  description = '',
  image = { url: '', alt: '' },
  onSwitch = () => {},
}) => (
  <div className={`bb bb-country-list-switcher ${styles['bb-country-list-switcher']}`}>
    {image && (
      <div className="image d-lg-none">
        <DefaultPicture {...image} loading="eager" />
        <FrayedEdge color="white" />
      </div>
    )}

    <div className="container">
      {title && <h1 className="title">{title}</h1>}

      {description && <div className="description">{description}</div>}

      <div className="d-none d-lg-block">
        <Switcher
          items={[
            {
              label: 'Map view',
              value: 'map',
              indicatorSvg: <MapSvg />,
            },
            {
              label: 'List view',
              value: 'list',
              indicatorSvg: <ListSvg />,
            },
          ]}
          default="map"
          onSelect={onSwitch}
          color="turquoise"
          hasSmallLabel
        />
      </div>
    </div>
  </div>
);

BBCountryListSwitcher.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  onSwitch: PropTypes.func,
};

export default BBCountryListSwitcher;
